import { normalizeNumber } from '../formatters';

export default function isCep(value) {
  const cep = normalizeNumber(value);
  return !(cep && cep.length < 8);
}
